import MUIDataTable, { FilterType, Responsive, SelectableRows } from "mui-datatables";
import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { Card, FormControlLabel, FormGroup, Grid, Icon, IconButton, Switch, ThemeOptions, createTheme, } from "@mui/material";
import MDTypography from "components/MDTypography";
import CustomFooter from "./CustomFooter";
import { eraseRichText, getUUIDFromKey } from "utils/helpers";
import { Link, useNavigate } from "react-router-dom";
import { useAppContext } from "context/app-context";
import { QuizDto } from "types";
import { daDK } from '@mui/material/locale';

const muiCache = createCache({
  key: "mui-datatables",
  prepend: true
});


const SearchCards = () => {
  const navigate = useNavigate();
  // const [pageData, setPageData] = useState({
  //   rowData: [],
  //   isLoading: false,
  //   totalPages: 0,
  //   totalPassengers: 150,
  // });
  // const [currentPage, setCurrentPage] = useState(1);
  // const [maxPage, setMaxPage] = useState(1)
  // const [startKey, setStartKey] = useState<{ PK: string, SK: string}>(null)
  // useEffect(() => {
  //   setPageData((prevState) => ({
  //     ...prevState,
  //     isLoading: true,
  //   }));
  //   if (currentPage === maxPage) {
  //     setMaxPage(maxPage + 1)
  //     paginateAndFilter(15, startKey?.PK, startKey?.SK,'', '', '', true, '', '', false).then((info) => {
  //       // console.log(JSON.stringify(info.LastEvaluatedKey))
  //       setStartKey({PK: getUUIDFromKey(info.LastEvaluatedKey.PK), SK: getUUIDFromKey(info.LastEvaluatedKey.SK) })
  //       const data = info.items.map((item) => {
  //         return {
  //           title: item.title,
  //           category_name: item.category.name,
  //           category_grade: item.category?.grade,
  //           subject: item.category.subject,
  //           subcategory_name: item.subcategory.name,
  //           subcategory_grade: item.subcategory.grade,
  //           createdAt: item.createdAt,
  //           updatedAt: item.updatedAt
  //         }
  //       })
  //       setPageData({
  //         isLoading: false,
  //         rowData: [...pageData.rowData, ...data], //...formatRowData(info.items)],
  //         totalPages: 0,
  //         totalPassengers: 150,
  //       });
  //     })

  //   } else {
  //     setPageData((prevState) => ({
  //       ...prevState,
  //       isLoading: false,
  //     }));
  //   }
  // }, [currentPage]);

  const columns = [
    {name: 'Redigér', options: {filter: false, sort: false, empty: true, customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
        <IconButton
          color="default"
          size="small"
          onClick={() => {
            navigate(`/cards/my-cards/edit-card/${tableMeta.rowData[1]}`)
          }}
        >
          <Icon>edit</Icon>
        </IconButton>
    )}},
    { name: "ID", options: { filter: false, display: false } },
    { name: "Titel", options: { filterOptions: { fullWidth: true }, } },
    {
      name: "Spørgsmål", options: {
        filter: false, filterOptions: { fullWidth: true }, customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
          <div dangerouslySetInnerHTML={{ __html: value }} />
        )
      }
    },
    {
      name: "Svar", options: {
        filter: false, filterOptions: { fullWidth: true }, customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
          <div dangerouslySetInnerHTML={{ __html: value }} />
        )
      }
    },
    { name: "Kategori", options: { filterOptions: { fullWidth: true } } },
    { name: "Klassetrin", options: { filterOptions: { fullWidth: true } } },
    { name: "Emne/fag", options: { filterOptions: { fullWidth: true } } },
    { name: "Quizkategori", options: { filterOptions: { fullWidth: true } } },
    { name: "Quizkategori klassetrin", options: { filterOptions: { fullWidth: true } } },
    { name: "Oprettet kl", options: { filterOptions: { fullWidth: true } } },
    { name: "Opdateret kl", options: { filterOptions: { fullWidth: true } } },
  ];

  const options = {
    textLabels: {
      body: {
        noMatch: "Fandt desværre intet match",
        columnHeaderTooltip: (column: any) => `Sorter efter ${column.label}`
      },
      toolbar:{
        search: 'Søg',
        viewColumns: "Se kolonner",
        filterTable: "Filtertabel",
      },
      filter: {
        all: "Alle",
        title: "FILTRE",
        reset: "NULSTIL",
      },
      viewColumns: {
        title: "Vis kolonner",
        titleAria: "Vis/skjul tabelkolonner",
      },
    },
    selectableRows: 'none' as SelectableRows,
    pagination: true,
    search: true,
    download: false,
    print: true,
    viewColumns: true,
    filter: true,
    filterType: "checkbox" as FilterType,
    responsive: 'vertical' as Responsive,
    customFooter: (
      rowCount: number,
      page: number,
      rowsPerPage: number,
      changeRowsPerPage: (page: string | number) => void,
      changePage: (newPage: number) => void,
    ) => {
      return (
        <CustomFooter
          count={rowCount}
          page={page}
          rowsPerPage={rowsPerPage}
          onChangeRowsPerPage={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => changeRowsPerPage(event.target.value)}
          onPageChange={(_: React.ChangeEvent<Element>, page: number) => changePage(page)}
        />)
    },
    customSearch: (searchQuery: string, currentRow: string[], columns: any[]) => {
      let isFound = false;
      currentRow.forEach((col, index) => {
        if (index === 2 && !isFound) {
          if (!filterTitle) {
            isFound = false;
          } else if (col?.indexOf(searchQuery) >= 0) {
            isFound = true;
          }
        } else if ((index === 3 && !isFound)) {
          if (!filterDescription) {
            isFound = false;
          } else if (eraseRichText(col).indexOf(searchQuery) >= 0) {
            isFound = true;
          }
        } else if (index === 4 && !isFound) {
          if (!filterAnswer) {
            isFound = false;
          } else if (eraseRichText(col).indexOf(searchQuery) >= 0) {
            isFound = true;
          }
        } else if (index === 5 && !isFound) {
          if (!filterCategories) {
            isFound = false;
          } else if (col.indexOf(searchQuery) >= 0) {
            isFound = true;
          }
        } else if (index === 6 && !isFound) {
          if (!filterGrade) {
            isFound = false;
          } else if (col.indexOf(searchQuery) >= 0) {
            isFound = true;
          }
        } else if (index === 7 && !isFound) {
          if (!filterSubject) {
            isFound = false;
          } else if (col.indexOf(searchQuery) >= 0) {
            isFound = true;
          }
        } else if (index === 8 && !isFound) {
          if (!filterSubCategories) {
            isFound = false;
          } else if (col.indexOf(searchQuery) >= 0) {
            isFound = true;
          }
        } else if (index === 9 && !isFound) {
          if (!filterQuizCategoryGrade) {
            isFound = false;
          } else if (col.indexOf(searchQuery) >= 0) {
            isFound = true;
          }
        } else if (index === 10 && !isFound) {
          if (!filterCreatedAt) {
            isFound = false;
          } else if (col.indexOf(searchQuery) >= 0) {
            isFound = true;
          }
        } else if (index === 11 && !isFound) {
          if (!filterUpdatedAt) {
            isFound = false;
          } else if (col.indexOf(searchQuery) >= 0) {
            isFound = true;
          }
        } else if (col?.indexOf(searchQuery) >= 0) {
          isFound = true;
        }
      });
      return isFound;
    },
  };

  const [rows, setRows] = useState<string[][]>([])
  const [filterTitle, setFilterTitle] = useState(true)
  const [filterAnswer, setFilterAnswer] = useState(true)
  const [filterDescription, setFilterDescription] = useState(true)
  const [filterCategories, setFilterCategories] = useState(true)
  const [filterSubCategories, setFilterSubCategories] = useState(true)
  const [filterGrade, setFilterGrade] = useState(true)
  const [filterSubject, setFilterSubject] = useState(true)
  const [filterQuizCategoryGrade, setFilterQuizCategoryGrade] = useState(true)
  const [filterCreatedAt, setFilterCreatedAt] = useState(true)
  const [filterUpdatedAt, setFilterUpdatedAt] = useState(true)

  const { quizCards } = useAppContext()
  
  // const [gradeValue, setGradeValue] = useState([])
  // const [subjectValue, setSubjectValue] = useState([])
  // const [createdByValue, setCreatedByValue] = useState('')
  // const [categories, setCategories] = useState([])
  // const [categoryValue, setCategoryValue] = useState([])
  // const [searchValue, setSearchValue] = useState('')
  // const [subCategories, setSubCategories] = useState([])
  // const [subCategoryValue, setSubCategoryValue ] = useState([])
  // const [fromAdmins, setFromAdmins] = useState(true)


  useEffect(() => {
    (async () => {
      const data: QuizDto[] = quizCards // await paginateAndFilter(15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)

      const formattedData = data.map((item) => [
        getUUIDFromKey(item.PK),
        item.title,
        item.description,
        item.answer,
        item.category.name,
        item.category?.grade,
        item.category.subject,
        item.subcategory.name,
        item.subcategory.grade,
        new Intl.DateTimeFormat('da-DK').format(new Date(item.createdAt)),
        new Intl.DateTimeFormat('da-DK').format(new Date(item.updatedAt))
      ])
      setRows([...formattedData])
    })()
  }, [quizCards])

  return (
    <DashboardLayout>
      <CacheProvider value={muiCache}>
        <DashboardNavbar />
        <MDBox py={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card>
                <MDBox pt={3} px={3} mx={1}>
                  <MDTypography variant="h4" fontWeight="medium">
                    Søg kort
                  </MDTypography>
                  <Grid container spacing={0}>
                    <Grid item xs={12} sm={6}  lg={2}>
                      <FormGroup>
                        <FormControlLabel title="Fravælg titel" control={<Switch checked={filterTitle} onChange={(e) => setFilterTitle(e.target.checked)} />} label="Fravælg titel" />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel title="Fravælg spørgsmål" control={<Switch checked={filterDescription} onChange={(e) => setFilterDescription(e.target.checked)} />} label="Fravælg spørgsmål" />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2}>
                      <FormGroup>
                        <FormControlLabel title="Fravælg svar" control={<Switch checked={filterAnswer} onChange={(e) => setFilterAnswer(e.target.checked)} />} label="Fravælg svar" />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel title="Fravælg kategori" control={<Switch checked={filterCategories} onChange={(e) => setFilterCategories(e.target.checked)} />} label="Fravælg kategori" />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2}>
                      <FormGroup>
                        <FormControlLabel title="Fravælg quizkategori" control={<Switch checked={filterSubCategories} onChange={(e) => setFilterSubCategories(e.target.checked)} />} label="Fravælg quizkategori" />
                      </FormGroup>
                      {/* <FormGroup>
                        <FormControlLabel title="Fravælg klassetrin" control={<Switch checked={filterGrade} onChange={(e) => setFilterGrade(e.target.checked)} />} label="Fravælg klassetrin" />
                      </FormGroup> */}
                    </Grid>
                    {/* <Grid item xs={12} sm={6} lg={2}>
                      <FormGroup>
                        <FormControlLabel title="Fravælg emne" control={<Switch checked={filterSubject} onChange={(e) => setFilterSubject(e.target.checked)} />} label="Fravælg emne" />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel title="Fravælg quizcategori klassetrin" control={<Switch checked={filterQuizCategoryGrade} onChange={(e) => setFilterQuizCategoryGrade(e.target.checked)} />} label="Fravælg quizcategori kl." />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2}>
                      <FormGroup>
                        <FormControlLabel title="Fravælg oprettet kl" control={<Switch checked={filterCreatedAt} onChange={(e) => setFilterCreatedAt(e.target.checked)} />} label="Fravælg oprettet kl" />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel title="Fravælg opdateret kl" control={<Switch checked={filterUpdatedAt} onChange={(e) => setFilterUpdatedAt(e.target.checked)} />} label="Fravælg opdateret kl" />
                      </FormGroup>
                    </Grid> */}
                  </Grid>
                  {/* <Grid container spacing={3}>
                  <Grid item xs={12} sm={10}>
                    <SearchInput searchValue={searchValue} setSearchValue={setSearchValue} />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormGroup>
                      <FormControlLabel control={<Switch checked={fromAdmins} onChange={(e) => setFromAdmins(e.target.checked)} />} label="From Admins" /> 
                    </FormGroup>
                  </Grid>
                </Grid> */}
                  {/* <MDBox justifyContent={{ xs: 'center', sm: 'space-between'}} mt={1} flexWrap='wrap' gap={3} display='flex'>
                  <Autocomplete
                    sx={{ width: { xs: '100%', sm: '18%' }, minWidth: 200 }}
                    multiple
                    filterSelectedOptions
                    noOptionsText="Ingen muligheder endnu"
                    value={gradeValue}
                    onChange={(event: any, newValue: string[]) => {
                      setGradeValue(newValue);
                    }}
                    id="controllable-states-grades"
                    options={grades}
                    renderInput={(params) => <TextField {...params} label="Klassetrin" />}
                  />
                  <Autocomplete
                    sx={{ width: { xs: '100%', sm: '18%' }, minWidth: 200 }}
                    multiple
                    filterSelectedOptions
                    noOptionsText="Ingen muligheder endnu"
                    value={subjectValue}
                    onChange={(event: any, newValue: string[]) => {
                      setSubjectValue(newValue);
                    }}
                    id="controllable-states-subjects"
                    options={subjects}
                    renderInput={(params) => <TextField {...params} label="Fag/Emner" />}
                  />
                  <Autocomplete
                    noOptionsText="Ingen muligheder endnu"
                    value={createdByValue}
                    onChange={(event: any, newValue: string | null) => {
                      setCreatedByValue(newValue);
                    }}

                    id="controllable-states-official-mine-from-other-users"
                    options={createdBy}
                    sx={{ width: { xs: '100%', sm: '18%' }, minWidth: 200 }}
                    renderInput={(params) => <TextField {...params} label="Lavet af?" />}
                  />
                  <Autocomplete
                    multiple
                    noOptionsText="Intet resultat i denne kategori"
                    filterSelectedOptions
                    getOptionLabel={(option) => (option as CategoryDto).name || ""}
                    value={categoryValue}
                    onChange={(event: SyntheticEvent<Element, Event>, newValue: CategoryDto[]) => {
                      setCategoryValue(newValue);
                    }}
                    id="controllable-states-categories"
                    options={categories}
                    sx={{ width: { xs: '100%', sm: '18%' }, minWidth: 200 }}
                    renderInput={(params) => <TextField {...params} label="Kategori" />}
                  />
                  <Autocomplete
                    noOptionsText="Ingen muligheder endnu"
                    aria-required={true}
                    multiple
                    getOptionLabel={option => (option as SubCategoryDto).name}
                    value={subCategoryValue as SubCategoryDto[] } 
                    // @ts-ignore
                    onChange={(event: SyntheticEvent<Element, Event>, newValue: SubCategoryDto[]) => {
                      setSubCategoryValue(newValue);
                    }}
                    id="controllable-states-subjects"
                    sx={{ width: { xs: '100%', sm: '18%' }, minWidth: 200 }}
                    options={subCategories}
                    renderInput={(params) => <TextField {...params} label="Quiz-kategori" />}
                  />

                </MDBox> */}
                </MDBox>
                <MDBox py={1}>
                  <ThemeProvider theme={createTheme({} as ThemeOptions, daDK)}>
                    <MUIDataTable
                      title={null}
                      data={rows}
                      columns={columns}
                      options={options}
                    />
                  </ThemeProvider>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </CacheProvider>
    </DashboardLayout>
  );

}

export default SearchCards